import React from "react";
import "./home.scss";
import group from './group-10.png'
import { usePumpStore } from "../../store/pumpStore";
import { Locales } from "../../helpers/localeHelpers"
import LanguagePicker from "../../components/language/language";
import parse from 'html-react-parser'

export default function Home (props) {
    const {language, setLanguage} = usePumpStore()

    return (
        <div className="iphone-pro-max">
            <div className="overlap-group-wrapper">
                <div className="overlap-group" style={{textAlign: "center"}}>
                    <div style={{position: "absolute", top: 40, left: 0, right: 0, fontSize: 16, fontWeight: 700, fontFamily: '"Luckiest Guy", cursive', color: "#ffffff"}}>BETA v0.9.2</div>
                    <div style={{ paddingTop: 30, paddingLeft: 30, display: "flex", justifyContent: "flex-start" }}>
                        <LanguagePicker
                            current={language}
                            available={["RU", "EN"]}
                            direction={"down"}
                            onSave={(lang) => {
                                setLanguage(lang)
                            }}
                        />
                    </div>
                    <img className="group" alt="Group" src={group} />
                    <div className="iq-pump">IQ PUMP</div>
                    <p className="div">
                        {parse(Locales[language].promoText)}
                    </p>
                    <div className='overlap-group_pump _selected' onClick={() => props.setPageName('tasks')}>
                        <div className="pump">PUMP</div>
                    </div>
                    <div className="text-wrapper"><span style={{cursor: "pointer"}} onClick={() => props.setPageName('rules')}>{Locales[language].rulesLink}</span></div>
                </div>
            </div>
        </div>
    );
};